import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { PageSEO } from "@/components/SEO/PageSEO";
import "../styles/legal.css";

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO
        title="Terms of Service"
        description="AI Genius Automations Terms of Service. Read our service agreement, user responsibilities, and legal terms for using our AI-powered automation platform."
        keywords="terms of service, user agreement, legal terms, service agreement, terms and conditions"
        noindex={false}
      />

      <div className="legal-page">
        <div className="legal-container">
          <button
            onClick={() => navigate(-1)}
            className="legal-back-button"
            aria-label="Go back"
          >
            ← Back
          </button>

          <h1 className="legal-title">Terms of Service</h1>

          <div className="legal-meta">
            <span>Effective Date: January 1, 2025</span>
            <span>Last Updated: January 20, 2025</span>
          </div>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              Welcome to AIG ("AIG", "we", "us", or "our"). By accessing or
              using our services, website, and applications (collectively, the
              "Service"), you agree to be bound by these Terms of Service
              ("Terms"). If you do not agree to these Terms, please do not use
              our Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Services</h2>
            <p>
              AIG provides digital services and solutions. Our Service may
              include various features, tools, and capabilities that we may
              update or modify from time to time.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. User Accounts</h2>
            <p>
              You must be at least 18 years old to use our Service. You are
              responsible for maintaining the confidentiality of your account
              information and for all activities that occur under your account.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Payments and Billing</h2>
            <p>
              If you purchase any paid services, you agree to pay all applicable
              fees. We reserve the right to modify our pricing with reasonable
              notice. All fees are non-refundable except as required by law.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. User Conduct</h2>
            <p>
              You agree to use our Service responsibly and in compliance with
              all applicable laws. You will not use our Service for any illegal,
              harmful, or abusive purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              We own all rights to our Service, including all software, content,
              and materials. You retain ownership of any content you provide,
              but grant us the necessary rights to provide our Service to you.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Privacy and Data</h2>
            <p>
              We implement reasonable security measures to protect your
              information. Our collection and use of personal information is
              governed by our Privacy Policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Service Availability</h2>
            <p>
              We strive to maintain service availability but do not guarantee
              uninterrupted access. We may perform maintenance or updates that
              temporarily affect service availability.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Disclaimers and Limitations</h2>
            <p>
              Our Service is provided "as is" without warranties of any kind. To
              the maximum extent permitted by law, we disclaim all warranties
              and limit our liability for any damages arising from your use of
              our Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Termination</h2>
            <p>
              Either party may terminate these Terms at any time. We may suspend
              or terminate your access to our Service if you violate these Terms
              or engage in prohibited conduct.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Governing Law</h2>
            <p>
              These Terms are governed by applicable law. Any disputes will be
              resolved in the appropriate courts with jurisdiction.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Changes will be
              effective when posted. Your continued use of our Service after
              changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us
              through our support channels.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Acknowledgment</h2>
            <p>
              BY USING OUR SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ,
              UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS OF SERVICE.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
